/*!
 * PaPaw's Ridge — Big Thirst Storefront Config
 *
 * Shared Daisy / checkout-6 storefront setup for:
 * - the merch collection
 * - the bourbon solo buy button
 *
 * Cache strategy: stable loader -> cache-busted config -> versioned engine.
 *
 * Recommended install:
 *   Site header:
 *   <script src="https://checkout-6.bigthirst.com/cdn/shop/files/papaw-storefront-loader.js"></script>
 *
 *   Merch page:
 *   <div id="bt-collection" style="min-height: 100px;">Loading merch...</div>
 *
 *   Bourbon page:
 *   <div class="bt-buy-button" data-handle="papaws-ridge-kentucky-straight-bourbon-whiskey" data-button-text="Buy Bourbon"></div>
 */

window.__BT_PAPAW_STOREFRONT_CONFIG_VERSION = '2026-08-11-01';
console.info('[PaPaw Storefront Config]', window.__BT_PAPAW_STOREFRONT_CONFIG_VERSION);

window.BigThirstCartConfig = {
  domain: 'checkout-6.bigthirst.com',
  apiVersion: '2026-01',

  // Collection
  collectionHandle: 'papaw-ridge-merch',

  // Commerce tracking. WordPress owns tracker initialization and PageView;
  // the cart engine sends events through the existing GA4 and Meta instances.
  ga4Id: 'G-92918ZYFYY',
  ga4UseExisting: true,
  metaPixelId: '1002641821963773',
  metaPixelUseExisting: true,
  metaPixelTrackPageView: false,
  metaPixelTrackSingle: true,

  // Buy buttons
  buyButtonText: 'Add to Cart',
  showEmbedPrice: false,

  // Inventory display
  showInventory: true,
  inventoryThreshold: 10,
  inventoryInStockText: 'In Stock',
  inventorySoldOutText: 'Sold Out',

  // Cart copy
  checkoutButtonText: 'BEGIN CHECKOUT',
  cartNotice: 'All sales processed by retail partners of<br><strong>Big Thirst, Inc.</strong><br>Tax &amp; shipping calculated in next window.<br>Questions? <a href="mailto:help@bigthirst.com">help@bigthirst.com</a>',
  cartNoteSublabel: 'Discounts/Promo Codes Added During Checkout',
  cartNoteLabel: 'Order Note or Personalized Note for Recipient',
  cartNotePrefix: '-------Discounts/Promo Codes Added During Checkout----------------------Powered by Shop.BigThirst.com----------------',

  // Typography
  cssVars: [
    '--bt-font: "sfizia", "Helvetica Neue", Arial, sans-serif;',
    '--bt-alt-font: "Helvetica Neue", Arial, sans-serif;',
    '--bt-text-color: #f0dfc0;',
    '--bt-price-color: #f0dfc0;',
    '--bt-price-size: 20px;',
    '--bt-title-size: 22px;',
    '--bt-title-weight: 700;',
    '--bt-title-margin: 8px;',
    '--bt-title-min-height: 56px;',
    '--bt-description-size: 16px;',
    '--bt-border-color: #113122;',
    '--bt-btn-bg: #f0dfc0;',
    '--bt-btn-color: #113122;',
    '--bt-btn-hover-bg: #113122;',
    '--bt-btn-hover-color: #f0dfc0;',
    '--bt-btn-px: 24px;',
    '--bt-btn-radius: 0;',
    '--bt-grid-cols: 3;',
    '--bt-grid-gap: 30px;',
    '--bt-grid-bottom: 50px;',
    '--bt-img-max-height: 520px;',
    '--bt-qty-size: 18px;',
    '--bt-add-btn-size: 20px;',
    '--bt-toggle-bg: #f0dfc0;',
    '--bt-toggle-icon-color: #113122;',
    '--bt-toggle-count-color: #113122;',
    '--bt-inventory-color: #f0dfc0;',
    '--bt-inventory-low-color: #f0dfc0;',
    '--bt-notice-bold-color: #113122;',
    '--bt-notice-link-color: #113122;',
  ].join(' '),

  customCSS: [
    'body { background-color: transparent; }',
    '#bt-collection { max-width: 1180px; margin: 0 auto; }',
    '#bt-collection .bt-product img { margin-bottom: 14px; }',
    '#bt-collection .bt-product-title { line-height: 1.15; text-transform: uppercase; letter-spacing: 0.02em; color: #f0dfc0 !important; }',
    '#bt-collection .bt-product-price { color: #f0dfc0 !important; margin-bottom: 10px; }',
    '#bt-collection .bt-product-description { color: #f0dfc0 !important; line-height: 1.5; }',
    '#bt-collection .bt-product-description p { margin: 0 0 0.8em; }',
    '#bt-collection .bt-product-description p:last-child { margin-bottom: 0; }',
    '#bt-collection .bt-variant-select { max-width: 300px; margin: 0 auto 12px; background: #fffaf0; color: #113122; border-color: #113122 !important; }',
    '#bt-collection .bt-qty-wrap, .bt-embed .bt-qty-wrap { max-width: 154px; margin: 0 auto 14px; }',
    '#bt-collection .bt-qty-btn, #bt-collection .bt-qty-input, .bt-embed .bt-qty-btn, .bt-embed .bt-qty-input, #bt-cart-drawer .bt-line-qty-btn, #bt-cart-drawer .bt-line-qty { border-color: #113122 !important; color: #113122 !important; }',
    '#bt-collection .bt-qty-btn, .bt-embed .bt-qty-btn, #bt-cart-drawer .bt-line-qty-btn { background: #f6ead0 !important; }',
    '#bt-collection .bt-qty-input, .bt-embed .bt-qty-input, #bt-cart-drawer .bt-line-qty { background: #fffdf8 !important; }',
    '.bt-add-btn, .bt-checkout-btn {',
    '  background-image: url("data:image/svg+xml,%3Csvg width=\'242\' preserveAspectRatio=\'none\' height=\'37\' viewBox=\'0 0 242 37\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'0.5\' y=\'0.5\' width=\'241\' height=\'36\' stroke=\'%23113122\'/%3E%3Cpath d=\'M15 12L20 7H222L227 12V25L222 30H20L15 25V12Z\' stroke=\'%23113122\'/%3E%3C/svg%3E") !important;',
    '  background-repeat: no-repeat !important;',
    '  background-position: center !important;',
    '  background-size: 100% 100% !important;',
    '  background-color: #f0dfc0 !important;',
    '  color: #113122 !important;',
    '  font-family: "sfizia", "Helvetica Neue", Arial, sans-serif !important;',
    '  font-weight: 700 !important;',
    '  font-size: 20px !important;',
    '  padding: 12px 16px !important;',
    '  text-transform: uppercase;',
    '  letter-spacing: 0.04em;',
    '  border: none !important;',
    '  border-radius: 0 !important;',
    '  min-height: 50px;',
    '  width: min(220px, 100%);',
    '  margin-left: auto;',
    '  margin-right: auto;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  transition: all 0.2s ease !important;',
    '}',
    '.bt-add-btn:hover, .bt-add-btn:focus, .bt-checkout-btn:hover, .bt-checkout-btn:focus {',
    '  background-image: url("data:image/svg+xml,%3Csvg width=\'242\' preserveAspectRatio=\'none\' height=\'37\' viewBox=\'0 0 242 37\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'0.5\' y=\'0.5\' width=\'241\' height=\'36\' stroke=\'%23f0dfc0\'/%3E%3Cpath d=\'M15 12L20 7H222L227 12V25L222 30H20L15 25V12Z\' fill=\'%23113122\' stroke=\'%23f0dfc0\'/%3E%3C/svg%3E") !important;',
    '  background-color: #113122 !important;',
    '  color: #f0dfc0 !important;',
    '  opacity: 1 !important;',
    '}',
    '.bt-embed { max-width: 320px; margin: 0 auto; padding: 20px 0; text-align: center; }',
    '.bt-embed .bt-add-btn { max-width: 100%; }',
    '.bt-embed .bt-variant-select { max-width: 280px; margin: 0 auto 12px; background: #fffaf0; color: #113122; border-color: #113122 !important; }',
    '.bt-embed .bt-inventory { margin-bottom: 10px; }',
    '#bt-cart-toggle {',
    '  right: 16px !important;',
    '  bottom: 16px !important;',
    '  width: 56px !important;',
    '  height: 66px !important;',
    '  padding: 0 !important;',
    '  border: none !important;',
    '  background: transparent !important;',
    '  background-image: url("data:image/svg+xml,%3Csvg width=\'56\' height=\'66\' viewBox=\'0 0 56 56\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'1\' y=\'1\' width=\'54\' height=\'54\' stroke=\'%23113122\' fill=\'%23f0dfc0\'/%3E%3C/svg%3E") !important;',
    '  background-position: center !important;',
    '  background-repeat: no-repeat !important;',
    '  background-size: 100% 100% !important;',
    '  border-radius: 0 !important;',
    '  box-shadow: none !important;',
    '  position: fixed !important;',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  gap: 0 !important;',
    '  overflow: visible !important;',
    '}',
    '#bt-cart-toggle .bt-toggle-flag { display: none !important; }',
    '#bt-cart-toggle svg { width: 26px !important; height: 26px !important; fill: #113122 !important; }',
    '#bt-cart-toggle svg * { fill: #113122 !important; stroke: #113122 !important; }',
    '#bt-cart-count { position: absolute !important; top: 1px !important; left: 2px !important; z-index: 2 !important; min-width: 22px !important; height: 22px !important; padding: 0 5px !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; border-radius: 999px !important; background-color: #113122 !important; color: #f0dfc0 !important; border: 2px solid #f0dfc0 !important; font-family: "sfizia", "Helvetica Neue", Arial, sans-serif !important; font-size: 13px !important; line-height: 1 !important; white-space: nowrap !important; }',
    '#bt-cart-toggle:hover, #bt-cart-toggle:focus { background-color: transparent !important; background-image: url("data:image/svg+xml,%3Csvg width=\'56\' height=\'66\' viewBox=\'0 0 56 56\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'1\' y=\'1\' width=\'54\' height=\'54\' stroke=\'%23f0dfc0\' fill=\'%23113122\'/%3E%3C/svg%3E") !important; }',
    '#bt-cart-toggle:hover svg, #bt-cart-toggle:focus svg, #bt-cart-toggle:hover svg *, #bt-cart-toggle:focus svg * { fill: #f0dfc0 !important; stroke: #f0dfc0 !important; }',
    '#bt-cart-drawer { background: #fffaf0 !important; }',
    '#bt-cart-drawer .bt-checkout-btn { width: 100% !important; max-width: none !important; min-height: 56px; white-space: nowrap; line-height: 1.2; }',
    '#bt-cart-drawer .bt-cart-title, #bt-cart-drawer .bt-line-item-title, #bt-cart-drawer .bt-cart-subtotal { color: #113122 !important; }',
    '#bt-cart-drawer .bt-cart-notice, #bt-cart-drawer .bt-cart-note-label, #bt-cart-drawer .bt-cart-note-sublabel, #bt-cart-drawer .bt-line-item-price, #bt-cart-drawer .bt-line-item-total, #bt-cart-drawer .bt-line-item-variant { color: #113122 !important; }',
    '#bt-cart-drawer .bt-line-item { border-bottom-color: rgba(17, 49, 34, 0.18) !important; }',
    '#bt-cart-drawer .bt-line-item-info { display: grid; grid-template-columns: minmax(0, 1fr) auto; column-gap: 12px; align-items: start; min-width: 0; }',
    '#bt-cart-drawer .bt-line-item-title { grid-column: 1; grid-row: 1; min-width: 0; }',
    '#bt-cart-drawer .bt-line-item-price { grid-column: 2; grid-row: 1; margin: 0; text-align: right; white-space: nowrap; }',
    '#bt-cart-drawer .bt-line-item-variant, #bt-cart-drawer .bt-line-item-unit-price, #bt-cart-drawer .bt-line-item-controls { grid-column: 1 / -1; }',
    '#bt-cart-drawer .bt-line-item-total { text-align: right; white-space: nowrap; }',
    '#bt-cart-drawer .bt-cart-note { border-color: rgba(17, 49, 34, 0.28) !important; background: #fffdf8 !important; color: #113122 !important; }',
    '@media (max-width: 900px) { #bt-collection { max-width: min(720px, 94vw); } }',
  ].join('\n'),

  engineVersion: '20260811-01',
  engineSrc: window.__BT_PAPAW_ENGINE_SRC || 'https://checkout-6.bigthirst.com/cdn/shop/files/bigthirst-cart.js?v=20260811-01',
};

function loadPaPawCartEngine() {
  if (window.__BT_PAPAW_ENGINE_SCRIPT_ADDED) return;
  window.__BT_PAPAW_ENGINE_SCRIPT_ADDED = true;

  var script = document.createElement('script');
  script.src = window.BigThirstCartConfig.engineSrc;
  script.async = true;
  document.head.appendChild(script);
}

if (document.body) {
  loadPaPawCartEngine();
} else {
  document.addEventListener('DOMContentLoaded', loadPaPawCartEngine);
}
